import React, { Component } from 'react';
import {
  Button,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import api from 'api';

import { buildSlides } from './buildSlides';

const Presentation = styled.div`
  width:100%;
  height:100%;
  position:absolute;
  overflow:hidden;
  z-index:1000;
`;
const Controls = styled.div`
  display:none;
  position:absolute;
  bottom:0px;
  left:0px;
  padding:10px;
  background:rgba(0,0,0,0.3);
  width:100%;
  z-index:100;
  &.shown{
    display:block;
  }
  .btn-group{
    .btn{
      border:1px solid white;
      width:40px;
      text-align: center;
    }
    margin-right:15px;
  }
  .btn-link{
    color:#fff;
    outline:none;
  }
  .btn-link.full-screen{
    border: none;
    font-size:20px;
  }
  .nav{
    border-radius:10px;
    margin-right:15px;
    padding-left:5px;
    padding-right:5px;
  }
`;

class Present extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idea: null, slide: 0, slides: [], showControls: false,
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
    api.ideas.get(this.props.match.params.id, (idea) => this.setState({ idea, slides: buildSlides(idea) }));
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  mouseMoved = () => {
    if (this.controlsTimeout) clearInterval(this.controlsTimeout);
    this.setState({ showControls: true });
    this.controlsTimeout = setTimeout(() => this.setState({ showControls: false }), 4000);
  };

  changeSlide = (direction) => {
    if (direction === 'back' && this.state.slide > 0) this.setState({ slide: this.state.slide - 1 });
    else if (this.state.slide < this.state.slides.length - 1) this.setState({ slide: this.state.slide + 1 });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 37 || e.key === 'ArrowDown') {
      this.changeSlide('back');
    }
    if (e.keyCode === 39 || e.key === 'ArrowUp') {
      this.changeSlide();
    }
  };

  render() {
    const {
      idea, slides, slide, showControls,
    } = this.state;
    if (!idea) return null;
    return (
      <Presentation id="presentation" onClick={this.changeSlide} onMouseMove={this.mouseMoved}>
        <Controls className={`${showControls ? 'shown' : ''}`} onClick={(e) => e.stopPropagation()}>
          <Button.Group>
            {slide > 0 && <Button onClick={() => this.changeSlide('back')} icon='arrow left' />}
            {slide < slides.length - 1 && <Button onClick={this.changeSlide} icon='arrow right' />}
          </Button.Group>
          <Button basic inverted icon='close' content='Exit' as={Link} to={`/ideas/${this.props.match.params.id}`} style={{ marginLeft: 10 }} />
        </Controls>
        {slides[slide]}
      </Presentation>
    );
  }
}

export default Present;
